import { Siren } from 'lucide-react'
import { AlertTicker } from './AlertTicker'
import { RealtimeDot } from './RealtimeDot'
import { UserMenu } from './UserMenu'

export function TopBar() {
  return (
    <header className="fixed inset-x-0 top-0 z-40">
      <div className="flex h-14 items-center gap-4 border-b border-border bg-background/90 px-4 backdrop-blur-xl lg:px-6">
        <div className="flex items-center gap-2.5">
          <span className="grid size-8 place-items-center rounded-lg bg-primary/15 text-primary">
            <Siren size={18} />
          </span>
          <div className="leading-tight">
            <div className="text-sm font-semibold tracking-[.22em] text-foreground">SEVEN</div>
            <div className="text-[9px] tracking-wider text-muted-foreground/70">天穹应急响应网络</div>
          </div>
        </div>
        <div className="ml-auto flex items-center gap-4">
          <RealtimeDot />
          <UserMenu />
        </div>
      </div>
      <div className="flex">
        <AlertTicker />
      </div>
    </header>
  )
}
